export const HUB_CHANNEL = 'extension';

export const EVENT_LOGIN_SUCCESS = 'login-success';
